var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"editor-icon",class:{pressed: _vm.pressed},attrs:{"title":_vm.title,"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }